import { markNotificationAsRead, markNotificationAsUnread, deleteNotification, markAllNotificationsAsRead } from './ajax.js';
import { notificationStore } from './store.js';
import { refreshUI } from './list.js';

/**
 * Setup tab switched events for a specific instance
 */
export function setupTabEvents(instance) {
	const { parent } = instance;
	if (!parent) return;

	const tabs = parent.querySelectorAll('.notification-tab-btn');
	tabs.forEach(tab => {
		tab.addEventListener('click', (e) => {
			e.preventDefault();
			const selectedFilter = tab.dataset.tab;

			// Update only THIS instance's filter
			instance.filter = selectedFilter;

			// Update only THIS container's tab buttons
			tabs.forEach(t => {
				const isActive = t.dataset.tab === selectedFilter;
				t.classList.toggle('active', isActive);
				t.classList.toggle('inactive', !isActive);
			});

			refreshUI();
		});
	});
}

/**
 * Setup action click events
 */
export function setupActionEvents(activeInstances) {
	activeInstances.forEach(({ container }) => {
		// Auto mark-read when clicking notification link
		container.addEventListener('click', async (e) => {
			const link = e.target.closest('.notification-item a');
			if (link) {
				const item = link.closest('.notification-item');
				if (item && item.dataset.id) {
					const notification = notificationStore.notifications.find(n => String(n.id) === String(item.dataset.id));
					if (notification && !notification.is_read) {
						markNotificationAsRead(item.dataset.id);
						notificationStore.markAsRead(item.dataset.id);
						refreshUI();
					}
				}
			}
		});

		container.addEventListener('click', async (e) => {
			const btn = e.target.closest('.action-btn');
			if (!btn) return;

			e.preventDefault();
			e.stopPropagation();

			const item = btn.closest('.notification-item');
			if (!item) return;

			const id = item.dataset.id;
			const action = btn.dataset.action;

			if (action === 'mark-read') {
				const success = await markNotificationAsRead(id);
				if (success) {
					notificationStore.markAsRead(id);
					refreshUI();
				}
			} else if (action === 'mark-unread') {
				const success = await markNotificationAsUnread(id);
				if (success) {
					notificationStore.markAsUnread(id);
					refreshUI();
				}
			} else if (action === 'delete') {
				if (!confirm(wpcore.direct_t({ en: 'Are you sure you want to delete this notification?', fr: 'Êtes-vous sûr de vouloir supprimer cette notification ?' }))) return;
				const success = await deleteNotification(id);
				if (success) {
					notificationStore.removeNotification(id);
					refreshUI();
				}
			}
		});
	});

	// Global actions listener (synchronized with mark-all-read.js via custom event)
	document.addEventListener('markAllReadSuccess', () => {
		notificationStore.markAllAsRead();
		refreshUI();
	});
}

/**
 * Setup Mark All Read events
 */
export function setupMarkAllReadEvents() {
	const markAllReadButtons = document.querySelectorAll('.mark-all-read-btn');

	if (!markAllReadButtons.length) return;

	markAllReadButtons.forEach(button => {
		button.addEventListener('click', async (e) => {
			e.preventDefault();
			e.stopPropagation();

			try {
				const nonce = document.querySelector('[name="mark_all_read_nonce"]')?.value;

				if (!nonce) {
					console.error('Nonce not found');
					return;
				}

				const result = await markAllNotificationsAsRead(nonce);

				if (result.success) {
					const unreadCount = result.data?.unread_count || 0;
					const alreadyRead = result.data?.already_read || false;

					if (alreadyRead) return;

					// Dispatch custom event to notify other modules
					document.dispatchEvent(new CustomEvent('markAllReadSuccess', {
						detail: { unreadCount: unreadCount }
					}));
				}
			} catch (error) {
				// Error alert is handled in ajax.js
			}
		});
	});
}
